<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    :class="color"
  >
    <path class="a" d="M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z" />
    <g transform="translate(7.05 7.05)">
      <line class="b" x2="14.142" transform="translate(0 10) rotate(-45)" />
      <line class="b" x2="14.142" transform="translate(0 0.001) rotate(45)" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Off',
  props: ['color'],
}
</script>

<style lang="scss" scoped>
.blizzard {
  .a {
    fill: $blizzard;
  }
}

.a {
  fill: #ff0064;
}

.b {
  fill: none;
  stroke: #fff;
  stroke-width: 2px;
}
</style>
